import React from 'react';

import type { Build } from '../../../../types';
import { AgentBuildTabIcon } from '../../../capabilities/agent/build-tab-icon';
import { AppBuildTabIcon } from '../../../capabilities/app/build-tab-icon';
import { AutomationBuildTabIcon } from '../../../capabilities/automation/build-tab-icon';

export const BuildTabIcon = ({
	build,
	index,
}: {
	build: Build;
	index: number;
}): React.JSX.Element => {
	switch (build.type) {
		case 'AUTOMATION_RULE':
			return <AutomationBuildTabIcon index={index} />;

		case 'ECOSYSTEM_APP':
			return <AppBuildTabIcon index={index} />;

		case 'ROVO_AGENT':
			return <AgentBuildTabIcon />;
	}
};
